export default "__VITE_ASSET__cMRdkFaP__"